"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.GeolocationData = void 0;
var _requester = require("../requester"),
  _types = require("./types"),
  _types2 = require("../types");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var GeolocationData = /*#__PURE__*/function () {
  function GeolocationData(a) {
    _classCallCheck(this, GeolocationData);
    var b = a.country,
      c = a.region,
      d = a.city,
      e = a.postalCode,
      f = a.coordinates;
    _defineProperty(this, "status", void 0), _defineProperty(this, "country", void 0), _defineProperty(this, "region", void 0), _defineProperty(this, "city", void 0), _defineProperty(this, "postalCode", void 0), _defineProperty(this, "coordinates", void 0), this.country = b, this.region = c, this.city = d, this.postalCode = e, this.coordinates = f, this.status = _types2.TrackingStatus.Unsent;
  }
  return _createClass(GeolocationData, [{
    key: "url",
    get: function get() {
      var a = this.region ? _requester.UrlParameter.Region + encodeURIComponent(this.region) : "",
        b = this.city ? _requester.UrlParameter.City + encodeURIComponent(this.city) : "",
        c = this.postalCode ? _requester.UrlParameter.PostalCode + encodeURIComponent(this.postalCode) : "",
        d = this.coordinates ? _requester.UrlParameter.Latitude + this.coordinates[0] + _requester.UrlParameter.Longitude + this.coordinates[1] : "";
      return _requester.UrlEventType.Geolocation + _requester.UrlParameter.Country + encodeURIComponent(this.country) + a + b + c + d;
    }
  }, {
    key: "data",
    get: function get() {
      return {
        type: _types.KameleoonData.GeolocationData,
        country: this.country,
        region: this.region,
        city: this.city,
        postalCode: this.postalCode,
        coordinates: this.coordinates,
        status: this.status
      };
    }
  }], [{
    key: "_fromRaw",
    value: function _fromRaw(a) {
      var b = a.country,
        c = a.region,
        d = a.city,
        e = a.postalCode,
        f = a.coordinates,
        g = a.status,
        h = new GeolocationData({
          country: b,
          region: c,
          city: d,
          postalCode: e,
          coordinates: f
        });
      return h.status = g, h;
    }
  }, {
    key: "_fromVisit",
    value: function _fromVisit(a) {
      var b;
      if (!(null !== (b = a.geolocationEvents) && void 0 !== b && b.length)) return;
      var c;
      var _iterator = _createForOfIteratorHelper(a.geolocationEvents),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _b = _step.value;
          var _a = _b.data;
          _a.country && (c = _a);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _ref = c || {},
        d = _ref.country,
        e = _ref.region,
        f = _ref.city;
      if (d) return e && f ? new GeolocationData({
        country: d,
        region: e,
        city: f
      }) : e ? new GeolocationData({
        country: d,
        region: e
      }) : new GeolocationData({
        country: d
      });
    }
  }]);
}();
exports.GeolocationData = GeolocationData;